/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconSlashes = createReactComponent("slashes", "IconSlashes", [
  ["path", { d: "M14 5l-10 14", key: "svg-0" }],
  ["path", { d: "M20 5l-10 14", key: "svg-1" }]
]);

export { IconSlashes as default };
//# sourceMappingURL=IconSlashes.js.map
